<!-- Choisir le conditionnement (F1, F2) : liste DÉPLIÉE, car deux conditionnements peuvent porter le même nom ; chaque ligne dit ce qui les distingue. -->
<div class="doc">

	<!-- Le nom ouvre la fiche dans un NOUVEL onglet (la vente en cours vit dessous) ; href natif et non routerLink :
	     c'est le navigateur seul qui respecte `target`. -->
	<header class="head">
		<div class="head-title">
			@if (product?.id) {
				<a class="who" [href]="productHref" target="_blank" rel="noopener" tabindex="-1"
					title="Ouvrir la fiche du produit dans un nouvel onglet">{{ productName }}<mat-icon>open_in_new</mat-icon></a>
			} @else {
				<span class="who">{{ productName }}</span>
			}
			<span class="docref"><i>N°</i>{{ product?.id || '—' }}</span>
		</div>

		<div class="head-meta">
			@if (templateName) { <span>Modèle <b>{{ templateName }}</b></span> }
			@if (product?.partnbloc) { <span>Réf. <b>{{ product.partnbloc }}</b></span> }
			@if (baseUnitName) { <span>Unité de base <b>{{ baseUnitName }}</b></span> }
		</div>
	</header>

	<form [formGroup]="formgroup" class="body">

		<!-- La quantité, en conditionnements choisis (pas en unités de base). -->
		<div class="fld fld-qty">
			<span class="lbl">Quantité</span>
			<div class="qty-row">
				<mat-icon class="qty-icon">add_shopping_cart</mat-icon>
				<input class="in num" type="number" min="1" formControlName="qty" inputmode="numeric" onfocus="this.select()" #qtyInput />
				<button type="button" class="icon-btn" tabindex="-1" title="Remettre 1" (click)="formgroup.get('qty')?.setValue(1)">
					<mat-icon>restart_alt</mat-icon>
				</button>
			</div>
		</div>

		<!-- Les conditionnements. Le conteneur porte le focus clavier ; les flèches tournent sur la liste. -->
		<div class="fld fld-ppv">
			<span class="lbl">Conditionnement<span class="count">{{ productPackagingVals.length }}</span></span>

			<div class="ppv-list" #ppvList tabindex="0" role="radiogroup" aria-label="Conditionnement">
				@for (ppv of productPackagingVals; track ppv) {
					<div class="ppv-row" #ppvRow role="radio" [class.on]="isSelected(ppv)" [class.dead]="!ppv.is_sellable"
						[attr.aria-checked]="isSelected(ppv)" [title]="ppvTooltip(ppv)" (click)="selectPpv(ppv)">

						<mat-icon class="tick">{{ isSelected(ppv) ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>

						<div class="ppv-main">
							<div class="ppv-name">
								{{ packagingLabel(ppv) }}
								@if (ppv.is_default) { <span class="pill">par défaut</span> }
								@if (!ppv.is_sellable) { <span class="pill red">non vendable</span> }
							</div>
							<div class="ppv-meta">
								@if (ppv.barcode) {
									<span class="code">{{ ppv.barcode }}</span>
								} @else {
									<span class="code none">sans code-barres</span>
								}
								<i>·</i><span>n°{{ ppv.id }}</span>
								<i>·</i><span>{{ baseQtyLabel(ppv) }}</span>
								<i>·</i><span>{{ usageLabel(ppv) }}</span>
							</div>
						</div>

						<div class="ppv-price">
							<span class="p1">{{ packagingPrice(ppv) | number: '1.2-2' }} €&nbsp;{{ is_ht ? 'HT' : 'TTC' }}</span>
							@if ((ppv.qtybaseuom || 1) > 1) {
								<span class="p2">{{ unitPrice(ppv) | number: '1.2-2' }} € / {{ (baseUnitName || 'unité') | lowercase }}</span>
							}
						</div>
					</div>
				} @empty {
					<div class="ppv-none">Aucun conditionnement — produit non vendable en l'état</div>
				}
			</div>

			<!-- 0 / 1 / plusieurs : un test length < 2 disait « un seul conditionnement » d'une liste VIDE,
			     et masquait un produit non vendable. -->
			<p class="hint" [class.warn]="productPackagingVals.length === 0">
				@switch (productPackagingVals.length) {
					@case (0) { Ce produit n'a aucun conditionnement actif : rien ne peut être vendu en l'état. }
					@case (1) { Un seul conditionnement disponible. }
					@default {
						@if (hasDuplicateLabels) {
							Plusieurs conditionnements portent le même nom : c'est le <b>code-barres</b> qui les distingue. Prenez celui de l'étiquette du produit ; « par défaut » est celui que la douchette et les automatismes choisissent.
						} @else {
							Flèches pour changer de conditionnement, Entrée pour ajouter.
						}
					}
				}
			</p>
		</div>
	</form>

	<!-- Un seul `| async` : deux dans un ternaire auraient souscrit deux fois au même flux. -->
	@let totals = getTotalPriceFromformgroupChange$ | async;
	<footer class="acts">
		<div class="total">
			Total
			<b>{{ (is_ht ? totals?.total_taxx : totals?.total_taxi) | number: '1.2-2' }} €&nbsp;{{ is_ht ? 'HT' : 'TTC' }}</b>
			<span class="src">prix public</span>
		</div>
		<button type="button" class="btn" (click)="dialogRef.close()">
			<mat-icon>close</mat-icon>Annuler
		</button>
		<button type="button" class="btn green" [disabled]="formgroup.invalid" (click)="submit()">
			<mat-icon>check</mat-icon>Ajouter
		</button>
	</footer>
</div>
